import CfoSfoMappingsTable from "./cfoSfoMappingsTable";
export default CfoSfoMappingsTable;
